import { t } from "@lingui/macro";
import * as React from "react";
import { Circle, Path, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ClearIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Clear`} {...props}>
    <G
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      clipPath="url(#a)"
      fill="none"
    >
      <Circle cx={8} cy={8} r={3.25} />
      <Path
        fill="none"
        d="M8 .8v1.6M8 13.6v1.6M.8 8h1.6M13.6 8h1.6M2.91 13.09l1.13-1.13M11.96 4.04l1.132-1.13M13.092 13.09l-1.131-1.13M4.04 4.04 2.91 2.91"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
